class MemberContentLinks extends HTMLElement {
  connectedCallback() {
    const isCustomer = this.getAttribute("data-customer") === "true";
    if (!isCustomer) return;

    const pairs = [...this.querySelectorAll("template[data-source]")].map((t) => ({
      source: t.getAttribute("data-source"),
      target: t.getAttribute("data-target"),
    }));
    if (!pairs.length) return;

    document.querySelectorAll("a[href]").forEach((a) => {
      for (const pair of pairs) {
        if (a.href.includes(pair.source)) {
          a.href = pair.target;
          break;
        }
      }
    });
  }
}

customElements.define("member-content-links", MemberContentLinks);
